// import React, { useState } from "react";
// import {
//   Container,
//   Paper,
//   TextField,
//   Button,
//   Typography,
//   Box,
//   CircularProgress,
//   Alert,
//   Card,
//   CardContent,
//   Grid,
//   Chip,
//   Divider,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   LinearProgress,
//   Stack,
// } from "@mui/material";
// import {
//   Download as DownloadIcon,
//   ExpandMore as ExpandMoreIcon,
//   CheckCircle as CheckCircleIcon,
//   Cancel as CancelIcon,
//   TrendingUp as TrendingUpIcon,
//   Schedule as ScheduleIcon,
//   Quiz as QuizIcon,
//   School as SchoolIcon,
//   Person as PersonIcon,
//   Phone as PhoneIcon,
//   Cake as CakeIcon,
//   EmojiEvents as EmojiEventsIcon,
// } from "@mui/icons-material";
// import Navbar from "../Components/Navbar";
// import Footer from "../Components/Footer";
// import axios from "../axiosInstance";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import logo from "../assets/mainLogo.jpg";
// import ReportsBanner from "../assets/Reports.png";
// import Header from "../Components/Header";

// const Reports = () => {
//   const [formData, setFormData] = useState({
//     phone: "",
//     dob: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [studentData, setStudentData] = useState(null);
//   const [reports, setReports] = useState([]);
//   const [expandedReport, setExpandedReport] = useState(null);

//   // Brand colors
//   const primaryColor = "#065A79";
//   const secondaryColor = "#AD1C86";

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const convertDobToDDMMYYYY = (dob) => {
//     if (!dob) return "";
//     if (dob.includes("/")) return dob;
//     const parts = dob.split("-");
//     if (parts.length === 3) {
//       return `${parts[2]}/${parts[1]}/${parts[0]}`;
//     }
//     return dob;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError("");

//     try {
//       const formattedDob = convertDobToDDMMYYYY(formData.dob);

//       const response = await axios.post("/api/v1/report/student/login", {
//         phone: formData.phone,
//         dob: formattedDob,
//       });

//       if (response.data.success) {
//         // Generate Roll Number from student ID (last 6 digits)
//         const studentId = response.data.student._id || "";
//         const rollNumber = studentId.slice(-6).toUpperCase();
//         const currentYear = new Date().getFullYear();
//         const nextYear = currentYear + 1;
//         const parentName = response.data.student.parentName;

//         const studentWithParent = {
//           ...response.data.student,
//           parentName: parentName || "Mr. & Mrs. Kumar",
//           rollNumber: rollNumber || "SMS001",
//           session: `${currentYear}-${nextYear.toString().slice(-2)}`,
//         };
//         setStudentData(studentWithParent);
//         setReports(response.data.reports);
//       }
//     } catch (err) {
//       setError(
//         err.response?.data?.message ||
//           "Failed to fetch reports. Please check your credentials.",
//       );
//       setStudentData(null);
//       setReports([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const downloadPDF = (report) => {
//     const doc = new jsPDF();
//     const addWatermark = (doc, pageWidth, pageHeight) => {
//       try {
//         doc.saveGraphicsState();

//         doc.setGState(
//           new doc.GState({
//             opacity: 0.08,
//           }),
//         );

//         doc.addImage(
//           logo,
//           "JPEG",
//           pageWidth / 2 - 45,
//           pageHeight / 2 - 45,
//           90,
//           90,
//         );

//         doc.restoreGraphicsState();
//       } catch (err) {
//         console.log(err);
//       }
//     };
//     const pageWidth = doc.internal.pageSize.width;
//     const pageHeight = doc.internal.pageSize.height;

//     // Border with proper margins
//     doc.setDrawColor(6, 90, 121);
//     doc.setLineWidth(1);
//     doc.rect(10, 10, pageWidth - 20, pageHeight - 20);

//     // School Header - Reduced height
//     // doc.setFillColor(6, 90, 121)
//     // doc.rect(10, 10, pageWidth - 20, 40, 'F')

//     doc.setFillColor(6, 90, 121);
//     doc.rect(10, 10, pageWidth - 20, 45, "F");

//     doc.addImage(logo, "JPEG", 15, 15, 22, 22);

//     doc.setTextColor(255, 255, 255);

//     doc.setFontSize(20);
//     doc.setFont(undefined, "bold");

//     doc.text("SHREE MANGALAM SCHOOL", pageWidth / 2, 28, { align: "center" });

//     doc.setFontSize(10);

//     doc.text("RIMC & Sainik School Entrance Preparation", pageWidth / 2, 38, {
//       align: "center",
//     });

//     doc.text("Student Progress Report Card", pageWidth / 2, 46, {
//       align: "center",
//     });

//     addWatermark(doc, pageWidth, pageHeight);

//     doc.setFontSize(20);
//     doc.setTextColor(255, 255, 255);
//     doc.text("SHREE MANGALAM SCHOOL", pageWidth / 2, 28, { align: "center" });

//     doc.setFontSize(10);
//     doc.text("RIMC & Sainik School Entrance Preparation", pageWidth / 2, 38, {
//       align: "center",
//     });

//     // Report Title - Adjusted Y position
//     doc.setFontSize(16);
//     doc.setTextColor(6, 90, 121);
//     doc.text("PROGRESS REPORT CARD", pageWidth / 2, 60, { align: "center" });

//     doc.setFontSize(9);
//     doc.setTextColor(100, 100, 100);
//     doc.text(
//       `Issue Date: ${new Date().toLocaleDateString("en-IN")}`,
//       pageWidth / 2,
//       68,
//       { align: "center" },
//     );

//     // Student Information Box - Adjusted Y position
//     doc.setDrawColor(6, 90, 121);
//     doc.setFillColor(245, 245, 245);
//     doc.roundedRect(15, 78, pageWidth - 30, 55, 3, 3, "F");

//     doc.setFontSize(11);
//     doc.setTextColor(6, 90, 121);
//     doc.text("STUDENT INFORMATION", pageWidth / 2, 90, { align: "center" });

//     doc.setFontSize(9);
//     doc.setTextColor(75, 75, 75);
//     doc.text(`Name: ${studentData.studentName}`, 25, 103);
//     doc.text(`Roll No: SMS-${studentData.rollNumber || "SMS001"}`, 120, 103);
//     doc.text(
//       `Parent / Guardian: ${studentData.parentName || "Mr. Sanjeev Kumar"}`,
//       25,
//       113,
//     );
//     doc.text(`Session: ${studentData.session || "2025-26"}`, 120, 113);
//     doc.text(
//       `DOB: ${new Date(studentData.dob).toLocaleDateString("en-IN")}`,
//       25,
//       123,
//     );
//     doc.text(`Phone: ${studentData.phone}`, 120, 123);

//     // Exam Details Box - Adjusted Y position
//     doc.setDrawColor(6, 90, 121);
//     doc.setFillColor(245, 245, 245);
//     doc.roundedRect(15, 140, pageWidth - 30, 45, 3, 3, "F");

//     doc.setFontSize(11);
//     doc.setTextColor(6, 90, 121);
//     doc.text("EXAM DETAILS", pageWidth / 2, 153, { align: "center" });

//     doc.setFontSize(9);
//     doc.setTextColor(75, 75, 75);
//     doc.text(`Exam: ${report.examName}`, 25, 166);
//     doc.text(`Subject: ${report.examSubject}`, 120, 166);
//     doc.text(`Class: ${report.studentClass}`, 25, 176);
//     doc.text(
//       `Date: ${new Date(report.createdAt).toLocaleDateString("en-IN")}`,
//       120,
//       176,
//     );

//     // Performance Summary - Adjusted startY
//     let startY = 195;
//     doc.setFontSize(11);
//     doc.setTextColor(6, 90, 121);
//     doc.text("PERFORMANCE SUMMARY", pageWidth / 2, startY, { align: "center" });

//     const marksData = [
//       [
//         "Total Marks",
//         report.totalMarks.toString(),
//         "Maximum Marks",
//         report.totalMarks.toString(),
//       ],
//       [
//         "Marks Obtained",
//         report.obtainedMarks.toString(),
//         "Percentage",
//         `${report.percentage}%`,
//       ],
//       [
//         "Passing Marks",
//         report.passingMarks.toString(),
//         "Result",
//         report.verdict,
//       ],
//       [
//         "Total Questions",
//         report.totalQuestions.toString(),
//         "Attempted",
//         report.attemptedQuestions.toString(),
//       ],
//       [
//         "Correct Answers",
//         report.correctAnswers.toString(),
//         "Wrong Answers",
//         report.wrongAnswers.toString(),
//       ],
//       [
//         "Skipped",
//         report.skippedAnswers.toString(),
//         "Negative Marks",
//         report.negativeMarks.toString(),
//       ],
//       [
//         "Time Taken",
//         `${report.timeTaken} min`,
//         "Grade",
//         report.percentage >= 75
//           ? "A+"
//           : report.percentage >= 60
//             ? "A"
//             : report.percentage >= 45
//               ? "B"
//               : "C",
//       ],
//     ];

//     autoTable(doc, {
//       startY: startY + 8,
//       body: marksData,
//       theme: "plain",
//       styles: { fontSize: 9, cellPadding: 3 },
//       columnStyles: {
//         0: { cellWidth: 45, fontStyle: "bold", textColor: [75, 75, 75] },
//         1: { cellWidth: 40, textColor: [33, 33, 33] },
//         2: { cellWidth: 45, fontStyle: "bold", textColor: [75, 75, 75] },
//         3: { cellWidth: 40, textColor: [33, 33, 33] },
//       },
//       alternateRowStyles: { fillColor: [248, 248, 248] },
//     });

//     // Answer Details
//     const finalY = doc.lastAutoTable.finalY + 10;
//     if (finalY < pageHeight - 80) {
//       doc.setFontSize(11);
//       doc.setTextColor(6, 90, 121);
//       doc.text("ANSWER SHEET", pageWidth / 2, finalY, { align: "center" });

//       const answerData = report.answers.map((answer, index) => [
//         (index + 1).toString(),
//         answer.selectedOptions?.join(", ") || "N/A",
//         answer.isCorrect ? "✓" : "✗",
//         answer.marksAwarded.toString(),
//       ]);

//       autoTable(doc, {
//         startY: finalY + 5,
//         head: [["Q.No.", "Selected Answer", "Status", "Marks"]],
//         body: answerData,
//         theme: "striped",
//         headStyles: {
//           fillColor: [6, 90, 121],
//           textColor: [255, 255, 255],
//           fontSize: 9,
//         },
//         bodyStyles: { fontSize: 8 },
//         columnStyles: {
//           0: { cellWidth: 25 },
//           1: { cellWidth: 70 },
//           2: { cellWidth: 25, halign: "center" },
//           3: { cellWidth: 30, halign: "center" },
//         },
//       });
//     }

//     // Signature Section (inside border)
//     // const signY = pageHeight - 35
//     // doc.setFontSize(9)
//     // doc.setTextColor(100, 100, 100)
//     // doc.line(30, signY, 80, signY)
//     // doc.text('(Class Teacher)', 55, signY + 5, { align: 'center' })

//     // doc.line(130, signY, 180, signY)
//     // doc.text('(Principal)', 155, signY + 5, { align: 'center' })

//     // Footer inside border
//     doc.setFontSize(8);
//     doc.setTextColor(150, 150, 150);
//     doc.text(
//       "This is a computer-generated report card",
//       pageWidth / 2,
//       pageHeight - 15,
//       { align: "center" },
//     );

//     doc.save(`${studentData.studentName}_${report.examName}_ReportCard.pdf`);
//   };

//   const getScoreColor = (percentage) => {
//     if (percentage >= 75) return "#4caf50";
//     if (percentage >= 60) return "#2196f3";
//     if (percentage >= 45) return "#ff9800";
//     return "#f44336";
//   };

//   const getGrade = (percentage) => {
//     if (percentage >= 75) return { grade: "A+", remark: "Outstanding" };
//     if (percentage >= 60) return { grade: "A", remark: "Excellent" };
//     if (percentage >= 45) return { grade: "B", remark: "Good" };
//     if (percentage >= 33) return { grade: "C", remark: "Average" };
//     return { grade: "D", remark: "Need Improvement" };
//   };

//   return (
//     <>
//       <Navbar />
//       <Header image={ReportsBanner} alt={"Shree Mangalam School"} />
//       <Container maxWidth="lg" sx={{ py: 5 }}>
//         {/* School Header with Brand Colors */}
//         {/* <Paper
//           elevation={0}
//           sx={{
//             p: 4,
//             mb: 4,
//             borderRadius: 3,
//             background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
//             color: "white",
//             position: "relative",
//             overflow: "hidden",
//             border: `1px solid ${secondaryColor}`,
//           }}
//         >
//           <Box
//             sx={{ position: "absolute", top: -20, right: -20, opacity: 0.1 }}
//           >
//             <SchoolIcon sx={{ fontSize: 250 }} />
//           </Box>

//           <Typography
//             variant="h3"
//             gutterBottom
//             align="center"
//             sx={{ mb: 1, fontWeight: "bold", letterSpacing: 2 }}
//           >
//             SHREE MANGALAM SCHOOL
//           </Typography>

//           <Typography variant="subtitle1" align="center" sx={{ mb: 1 }}>
//             RIMC & Sainik School Entrance Preparation
//           </Typography>

//           <Typography variant="caption" align="center" display="block" sx={{ opacity: 0.8 }}>
//             (Affiliated to CBSE, New Delhi) | School Code: 12345
//           </Typography>
//         </Paper> */}

//         <Box sx={{ mx: "auto", py: 2 }}>
//           <Typography
//             variant="h4"
//             fontWeight={700}
//             mb={2}
//             sx={{ color: primaryColor }}
//           >
//             Student Report Card
//           </Typography>
//           <Typography variant="body1" color="text.secondary" mb={4}>
//             Enter your registered phone number and date of birth to view and
//             download your report card instantly. Access your academic
//             performance, marks, and detailed results securely online.
//           </Typography>
//         </Box>
//         {!studentData ? (
//           <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 3 }}>
//             <Typography
//               variant="h5"
//               gutterBottom
//               sx={{
//                 mb: 3,
//                 color: primaryColor,
//                 fontWeight: "bold",
//                 display: "flex",
//                 alignItems: "center",
//               }}
//             >
//               {/* <SchoolIcon sx={{ mr: 1, color: primaryColor }} /> */}
//               Student Login Portal
//             </Typography>

//             <form onSubmit={handleSubmit}>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     label="Phone Number"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     required
//                     variant="outlined"
//                     placeholder="Enter 10-digit mobile number"
//                     inputProps={{ maxLength: 10 }}
//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         "&.Mui-focused fieldset": { borderColor: primaryColor },
//                       },
//                     }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     label="Date of Birth"
//                     name="dob"
//                     value={formData.dob}
//                     onChange={handleChange}
//                     required
//                     variant="outlined"
//                     type="date"
//                     InputLabelProps={{ shrink: true }}
//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         "&.Mui-focused fieldset": { borderColor: primaryColor },
//                       },
//                     }}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Button
//                     type="submit"
//                     fullWidth
//                     variant="contained"
//                     disabled={loading}
//                     sx={{
//                       py: 1.5,
//                       fontSize: "1.1rem",
//                       fontWeight: "bold",
//                       background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
//                       "&:hover": {
//                         background: `linear-gradient(135deg, ${secondaryColor} 0%, ${primaryColor} 100%)`,
//                       },
//                     }}
//                   >
//                     {loading ? (
//                       <CircularProgress size={24} sx={{ color: "white" }} />
//                     ) : (
//                       "View Report Card"
//                     )}
//                   </Button>
//                 </Grid>
//               </Grid>
//             </form>

//             {error && (
//               <Alert severity="error" sx={{ mt: 3 }}>
//                 {error}
//               </Alert>
//             )}
//           </Paper>
//         ) : (
//           <>
//             <Alert
//               severity="success"
//               sx={{
//                 mb: 3,
//                 bgcolor: "#e8f5e9",
//                 border: "1px solid #4caf50",
//               }}
//               icon={<CheckCircleIcon />}
//             >
//               <strong>Welcome, {studentData.studentName}!</strong> —{" "}
//               {reports.length} report card{reports.length > 1 ? "s" : ""}{" "}
//               available
//             </Alert>

//             <Button
//               variant="outlined"
//               onClick={() => {
//                 setStudentData(null);
//                 setReports([]);
//                 setFormData({ phone: "", dob: "" });
//               }}
//               sx={{ mb: 3, borderColor: primaryColor, color: primaryColor }}
//               startIcon={<PersonIcon />}
//             >
//               Search Another Student
//             </Button>
//           </>
//         )}

//         {studentData && reports.length > 0 && (
//           <>
//             <Typography
//               variant="h5"
//               gutterBottom
//               sx={{
//                 mb: 3,
//                 fontWeight: "bold",
//                 color: primaryColor,
//                 borderLeft: `4px solid ${secondaryColor}`,
//                 pl: 2,
//               }}
//             >
//               Report Cards
//             </Typography>

//             {reports.map((report) => {
//               const gradeInfo = getGrade(report.percentage);
//               return (
//                 <Card
//                   key={report._id}
//                   sx={{
//                     mb: 4,
//                     borderRadius: 3,
//                     boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
//                     transition: "transform 0.3s, box-shadow 0.3s",
//                     "&:hover": {
//                       transform: "translateY(-5px)",
//                       boxShadow: "0 12px 48px rgba(0,0,0,0.15)",
//                     },
//                   }}
//                 >
//                   <CardContent sx={{ p: 0 }}>
//                     {/* School Header with Brand Colors */}
//                     <Box
//                       sx={{
//                         background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
//                         color: "white",
//                         p: 3,
//                         borderRadius: "12px 12px 0 0",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Typography
//                         variant="h5"
//                         sx={{ fontWeight: "bold", letterSpacing: 1 }}
//                       >
//                         SHREE MANGALAM SCHOOL
//                       </Typography>
//                       <Typography
//                         variant="caption"
//                         display="block"
//                         sx={{ opacity: 0.9 }}
//                       >
//                         RIMC & Sainik School Entrance Preparation
//                       </Typography>
//                     </Box>

//                     {/* Report Title */}
//                     <Box
//                       sx={{ p: 3, borderBottom: `2px solid ${primaryColor}` }}
//                     >
//                       <Typography
//                         variant="h6"
//                         align="center"
//                         sx={{ fontWeight: "bold", color: primaryColor }}
//                       >
//                         PROGRESS REPORT CARD
//                       </Typography>
//                       <Typography
//                         variant="caption"
//                         align="center"
//                         display="block"
//                         color="text.secondary"
//                       >
//                         Issue Date: {new Date().toLocaleDateString("en-IN")}
//                       </Typography>
//                     </Box>

//                     {/* Student Info */}
//                     <Box sx={{ p: 3, bgcolor: "#f5f5f5" }}>
//                       <Grid container spacing={2}>
//                         <Grid item xs={12}>
//                           <Typography
//                             variant="subtitle2"
//                             sx={{
//                               fontWeight: "bold",
//                               color: primaryColor,
//                               mb: 2,
//                             }}
//                           >
//                             STUDENT INFORMATION
//                           </Typography>
//                         </Grid>
//                         <Grid item xs={12} md={4}>
//                           <Stack
//                             direction="row"
//                             spacing={1}
//                             alignItems="center"
//                           >
//                             {/* <PersonIcon
//                               fontSize="small"
//                               sx={{ color: primaryColor }}
//                             /> */}
//                             <Typography variant="body2">
//                               <strong>Name:</strong> {studentData.studentName}
//                             </Typography>
//                           </Stack>
//                         </Grid>
//                         <Grid item xs={12} md={4}>
//                           <Stack
//                             direction="row"
//                             spacing={1}
//                             alignItems="center"
//                           >
//                             <Typography variant="body2">
//                               <strong>Parent / Guardian:</strong>{" "}
//                               {studentData.parentName || "Mr. Sanjeev Kumar"}
//                             </Typography>
//                           </Stack>
//                         </Grid>
//                         <Grid item xs={12} md={4}>
//                           <Stack
//                             direction="row"
//                             spacing={1}
//                             alignItems="center"
//                           >
//                             <Typography variant="body2">
//                               <strong>Roll No:</strong>{" "}
//                              SMS-{studentData.rollNumber || "SMS001"}
//                             </Typography>
//                           </Stack>
//                         </Grid>
//                         <Grid item xs={12} md={4}>
//                           <Stack
//                             direction="row"
//                             spacing={1}
//                             alignItems="center"
//                           >
//                             {/* <CakeIcon
//                               fontSize="small"
//                               sx={{ color: primaryColor }}
//                             /> */}
//                             <Typography variant="body2">
//                               <strong>DOB:</strong>{" "}
//                               {new Date(studentData.dob).toLocaleDateString(
//                                 "en-IN",
//                               )}
//                             </Typography>
//                           </Stack>
//                         </Grid>
//                         <Grid item xs={12} md={4}>
//                           <Stack
//                             direction="row"
//                             spacing={1}
//                             alignItems="center"
//                           >
//                             {/* <PhoneIcon
//                               fontSize="small"
//                               sx={{ color: primaryColor }}
//                             /> */}
//                             <Typography variant="body2">
//                               <strong>Phone:</strong> {studentData.phone}
//                             </Typography>
//                           </Stack>
//                         </Grid>
//                         <Grid item xs={12} md={4}>
//                           <Stack
//                             direction="row"
//                             spacing={1}
//                             alignItems="center"
//                           >
//                             {/* <SchoolIcon
//                               fontSize="small"
//                               sx={{ color: primaryColor }}
//                             /> */}
//                             <Typography variant="body2">
//                               <strong>Session:</strong>{" "}
//                               {studentData.session || "2025-26"}
//                             </Typography>
//                           </Stack>
//                         </Grid>
//                       </Grid>
//                     </Box>

//                     {/* Exam Details */}
//                     <Box sx={{ p: 3 }}>
//                       <Typography
//                         variant="subtitle2"
//                         sx={{ fontWeight: "bold", color: primaryColor, mb: 2 }}
//                       >
//                         EXAM DETAILS
//                       </Typography>
//                       <Grid container spacing={2}>
//                         <Grid item xs={12} md={6}>
//                           <Typography variant="body2">
//                             <strong>Exam Name:</strong> {report.examName}
//                           </Typography>
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                           <Typography variant="body2">
//                             <strong>Subject:</strong> {report.examSubject}
//                           </Typography>
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                           <Typography variant="body2">
//                             <strong>Class:</strong> {report.studentClass}
//                           </Typography>
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                           <Typography variant="body2">
//                             <strong>Exam Date:</strong>{" "}
//                             {new Date(report.createdAt).toLocaleDateString(
//                               "en-IN",
//                             )}
//                           </Typography>
//                         </Grid>
//                       </Grid>
//                     </Box>

//                     <Divider />

//                     {/* Performance Summary */}
//                     <Box sx={{ p: 3 }}>
//                       <Typography
//                         variant="subtitle2"
//                         sx={{ fontWeight: "bold", color: primaryColor, mb: 2 }}
//                       >
//                         PERFORMANCE SUMMARY
//                       </Typography>

//                       <Grid container spacing={2}>
//                         <Grid item xs={6} md={3}>
//                           <Paper
//                             sx={{
//                               p: 2,
//                               textAlign: "center",
//                               bgcolor: "#e3f2fd",
//                             }}
//                           >
//                             <Typography
//                               variant="h6"
//                               sx={{ color: primaryColor }}
//                             >
//                               {report.obtainedMarks}/{report.totalMarks}
//                             </Typography>
//                             <Typography variant="caption">
//                               Marks Obtained
//                             </Typography>
//                           </Paper>
//                         </Grid>
//                         <Grid item xs={6} md={3}>
//                           <Paper
//                             sx={{
//                               p: 2,
//                               textAlign: "center",
//                               bgcolor: "#e8f5e9",
//                             }}
//                           >
//                             <Typography
//                               variant="h6"
//                               sx={{ color: getScoreColor(report.percentage) }}
//                             >
//                               {report.percentage}%
//                             </Typography>
//                             <Typography variant="caption">
//                               Percentage
//                             </Typography>
//                           </Paper>
//                         </Grid>
//                         <Grid item xs={6} md={3}>
//                           <Paper
//                             sx={{
//                               p: 2,
//                               textAlign: "center",
//                               bgcolor: "#fff3e0",
//                             }}
//                           >
//                             <Typography
//                               variant="h6"
//                               sx={{ color: secondaryColor }}
//                             >
//                               {gradeInfo.grade}
//                             </Typography>
//                             <Typography variant="caption">Grade</Typography>
//                           </Paper>
//                         </Grid>
//                         <Grid item xs={6} md={3}>
//                           <Paper
//                             sx={{
//                               p: 2,
//                               textAlign: "center",
//                               bgcolor:
//                                 report.verdict === "Pass"
//                                   ? "#e8f5e9"
//                                   : "#ffebee",
//                             }}
//                           >
//                             <Typography
//                               variant="h6"
//                               color={
//                                 report.verdict === "Pass"
//                                   ? "success.main"
//                                   : "error.main"
//                               }
//                             >
//                               {report.verdict}
//                             </Typography>
//                             <Typography variant="caption">Result</Typography>
//                           </Paper>
//                         </Grid>
//                       </Grid>

//                       <Box sx={{ mt: 3 }}>
//                         <Typography variant="body2" gutterBottom>
//                           Performance Overview
//                         </Typography>
//                         <LinearProgress
//                           variant="determinate"
//                           value={report.percentage}
//                           sx={{
//                             height: 10,
//                             borderRadius: 5,
//                             backgroundColor: "#e0e0e0",
//                             "& .MuiLinearProgress-bar": {
//                               background: `linear-gradient(90deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
//                               borderRadius: 5,
//                             },
//                           }}
//                         />
//                       </Box>
//                     </Box>

//                     <Divider />

//                     {/* Detailed Marks */}
//                     <Box sx={{ p: 3 }}>
//                       <Typography
//                         variant="subtitle2"
//                         sx={{ fontWeight: "bold", color: primaryColor, mb: 2 }}
//                       >
//                         DETAILED ANALYSIS
//                       </Typography>
//                       <Grid container spacing={2}>
//                         <Grid item xs={6} sm={4} md={2}>
//                           <Box textAlign="center">
//                             <Typography variant="h6">
//                               {report.totalQuestions}
//                             </Typography>
//                             <Typography variant="caption">
//                               Total Questions
//                             </Typography>
//                           </Box>
//                         </Grid>
//                         <Grid item xs={6} sm={4} md={2}>
//                           <Box textAlign="center">
//                             <Typography variant="h6" color="success.main">
//                               {report.correctAnswers}
//                             </Typography>
//                             <Typography variant="caption">Correct</Typography>
//                           </Box>
//                         </Grid>
//                         <Grid item xs={6} sm={4} md={2}>
//                           <Box textAlign="center">
//                             <Typography variant="h6" color="error.main">
//                               {report.wrongAnswers}
//                             </Typography>
//                             <Typography variant="caption">Wrong</Typography>
//                           </Box>
//                         </Grid>
//                         <Grid item xs={6} sm={4} md={2}>
//                           <Box textAlign="center">
//                             <Typography variant="h6">
//                               {report.skippedAnswers}
//                             </Typography>
//                             <Typography variant="caption">Skipped</Typography>
//                           </Box>
//                         </Grid>
//                         <Grid item xs={6} sm={4} md={2}>
//                           <Box textAlign="center">
//                             <Typography variant="h6">
//                               {report.attemptedQuestions}
//                             </Typography>
//                             <Typography variant="caption">Attempted</Typography>
//                           </Box>
//                         </Grid>
//                         <Grid item xs={6} sm={4} md={2}>
//                           <Box textAlign="center">
//                             <Typography variant="h6">
//                               {report.timeTaken} min
//                             </Typography>
//                             <Typography variant="caption">
//                               Time Taken
//                             </Typography>
//                           </Box>
//                         </Grid>
//                       </Grid>
//                     </Box>

//                     {/* Answer Sheet */}
//                     <Accordion
//                       expanded={expandedReport === report._id}
//                       onChange={() =>
//                         setExpandedReport(
//                           expandedReport === report._id ? null : report._id,
//                         )
//                       }
//                       sx={{ m: 3, borderRadius: 2 }}
//                     >
//                       <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                         <Typography
//                           fontWeight="bold"
//                           sx={{ color: primaryColor }}
//                         >
//                           <QuizIcon
//                             sx={{
//                               mr: 1,
//                               verticalAlign: "middle",
//                               color: primaryColor,
//                             }}
//                           />
//                           View Answer Sheet
//                         </Typography>
//                       </AccordionSummary>
//                       <AccordionDetails>
//                         <TableContainer>
//                           <Table size="small">
//                             <TableHead>
//                               <TableRow sx={{ bgcolor: "#f5f5f5" }}>
//                                 <TableCell>
//                                   <strong>Q.No.</strong>
//                                 </TableCell>
//                                 <TableCell>
//                                   <strong>Selected Answer</strong>
//                                 </TableCell>
//                                 <TableCell>
//                                   <strong>Status</strong>
//                                 </TableCell>
//                                 <TableCell>
//                                   <strong>Marks</strong>
//                                 </TableCell>
//                               </TableRow>
//                             </TableHead>
//                             <TableBody>
//                               {report.answers.map((answer, idx) => (
//                                 <TableRow key={answer.questionId} hover>
//                                   <TableCell>{idx + 1}</TableCell>
//                                   <TableCell>
//                                     {answer.selectedOptions?.join(", ") ||
//                                       "Not Attempted"}
//                                   </TableCell>
//                                   <TableCell>
//                                     {answer.isCorrect ? (
//                                       <Chip
//                                         label="Correct"
//                                         color="success"
//                                         size="small"
//                                       />
//                                     ) : (
//                                       <Chip
//                                         label="Incorrect"
//                                         color="error"
//                                         size="small"
//                                       />
//                                     )}
//                                   </TableCell>
//                                   <TableCell
//                                     sx={{
//                                       color:
//                                         answer.marksAwarded > 0
//                                           ? "green"
//                                           : "red",
//                                     }}
//                                   >
//                                     {answer.marksAwarded > 0 ? "+" : ""}
//                                     {answer.marksAwarded}
//                                   </TableCell>
//                                 </TableRow>
//                               ))}
//                             </TableBody>
//                           </Table>
//                         </TableContainer>
//                       </AccordionDetails>
//                     </Accordion>

//                     {/* Signature and Download */}
//                     <Box
//                       sx={{
//                         p: 3,
//                         bgcolor: "#fafafa",
//                         borderRadius: "0 0 12px 12px",
//                       }}
//                     >
//                       <Grid container spacing={2} alignItems="center">
//                         {/* <Grid item xs={6}>
//                           <Box>
//                             <Divider sx={{ width: '80%', mb: 1 }} />
//                             <Typography variant="caption">(Class Teacher)</Typography>
//                           </Box>
//                         </Grid>
//                         <Grid item xs={6}>
//                           <Box textAlign="right">
//                             <Divider sx={{ width: '80%', mb: 1, ml: 'auto' }} />
//                             <Typography variant="caption">(Principal)</Typography>
//                           </Box>
//                         </Grid> */}
//                         <Grid item xs={12}>
//                           <Button
//                             fullWidth
//                             variant="contained"
//                             startIcon={<DownloadIcon />}
//                             onClick={() => downloadPDF(report)}
//                             sx={{
//                               mt: 2,
//                               background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
//                               "&:hover": {
//                                 background: `linear-gradient(135deg, ${secondaryColor} 0%, ${primaryColor} 100%)`,
//                               },
//                             }}
//                           >
//                             Download Report Card (PDF)
//                           </Button>
//                         </Grid>
//                       </Grid>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               );
//             })}
//           </>
//         )}

//         {studentData && reports.length === 0 && (
//           <Paper elevation={3} sx={{ p: 4, textAlign: "center" }}>
//             <Typography variant="h6" color="text.secondary">
//               No report cards found for this student.
//             </Typography>
//           </Paper>
//         )}
//       </Container>
//       <Footer />
//     </>
//   );
// };

// export default Reports;

import React, { useState } from "react";
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  CircularProgress,
  Alert,
  Card,
  CardContent,
  Grid,
  Chip,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  LinearProgress,
  Stack,
  Modal,
  IconButton
} from "@mui/material";
import {
  Download as DownloadIcon,
  ExpandMore as ExpandMoreIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  TrendingUp as TrendingUpIcon,
  Schedule as ScheduleIcon,
  Quiz as QuizIcon,
  School as SchoolIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
  Cake as CakeIcon,
  EmojiEvents as EmojiEventsIcon,
  Info as InfoIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import axios from "../axiosInstance";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/mainLogo.jpg";
import ReportsBanner from "../assets/Reports.png";
import Header from "../Components/Header";

const Reports = () => {
  const [formData, setFormData] = useState({
    phone: "",
    dob: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [studentData, setStudentData] = useState(null);
  const [reports, setReports] = useState([]);
  const [expandedReport, setExpandedReport] = useState(null);
  const [pendingResults, setPendingResults] = useState([]);
  const [resultInfo, setResultInfo] = useState(null);
  const [showPendingModal, setShowPendingModal] = useState(false);

  // Brand colors
  const primaryColor = "#065A79";
  const secondaryColor = "#AD1C86";

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const convertDobToDDMMYYYY = (dob) => {
    if (!dob) return "";
    if (dob.includes("/")) return dob;
    const parts = dob.split("-");
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return dob;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const formattedDob = convertDobToDDMMYYYY(formData.dob);

      const response = await axios.post("/api/v1/report/student/login", {
        phone: formData.phone,
        dob: formattedDob,
      });

      if (response.data.success) {
        // Generate Roll Number from student ID (last 6 digits)
        const studentId = response.data.student._id || "";
        const rollNumber = studentId.slice(-6).toUpperCase();
        const currentYear = new Date().getFullYear();
        const nextYear = currentYear + 1;
        const parentName = response.data.student.parentName;

        const studentWithParent = {
          ...response.data.student,
          parentName: parentName || "Mr. & Mrs. Kumar",
          rollNumber: rollNumber || "SMS001",
          session: `${currentYear}-${nextYear.toString().slice(-2)}`,
        };
        setStudentData(studentWithParent);
        setReports(response.data.reports || []);
        setPendingResults(response.data.pendingResults || []);
        setResultInfo(response.data.resultInfo || null);

        // Show pending results modal if there are pending results and no reports
        if (response.data.pendingResults?.length > 0 && response.data.reports?.length === 0) {
          setShowPendingModal(true);
        }
        
        // Show warning message for pending results
        if (response.data.resultInfo && response.data.resultInfo.type === "PENDING_RESULTS") {
          // You can also show a toast/message here
          console.log("Pending results:", response.data.resultInfo);
        }
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Failed to fetch reports. Please check your credentials.",
      );
      setStudentData(null);
      setReports([]);
      setPendingResults([]);
      setResultInfo(null);
    } finally {
      setLoading(false);
    }
  };

  // Format date for display
  const formatDateForDisplay = (dateStr, timeStr) => {
    if (!dateStr) return "Unknown date";
    
    const [day, month, year] = dateStr.split("/");
    const date = new Date(`${year}-${month}-${day}`);
    
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-IN', options);
    
    if (timeStr) {
      const [hours, minutes] = timeStr.split(":");
      const formattedTime = new Date(2000, 0, 1, hours, minutes).toLocaleTimeString('en-IN', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
      return `${formattedDate} at ${formattedTime}`;
    }
    
    return formattedDate;
  };

  const downloadPDF = (report) => {
    const doc = new jsPDF();
    const addWatermark = (doc, pageWidth, pageHeight) => {
      try {
        doc.saveGraphicsState();

        doc.setGState(
          new doc.GState({
            opacity: 0.08,
          }),
        );

        doc.addImage(
          logo,
          "JPEG",
          pageWidth / 2 - 45,
          pageHeight / 2 - 45,
          90,
          90,
        );

        doc.restoreGraphicsState();
      } catch (err) {
        console.log(err);
      }
    };
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // Border with proper margins
    doc.setDrawColor(6, 90, 121);
    doc.setLineWidth(1);
    doc.rect(10, 10, pageWidth - 20, pageHeight - 20);

    doc.setFillColor(6, 90, 121);
    doc.rect(10, 10, pageWidth - 20, 45, "F");

    doc.addImage(logo, "JPEG", 15, 15, 22, 22);

    doc.setTextColor(255, 255, 255);

    doc.setFontSize(20);
    doc.setFont(undefined, "bold");

    doc.text("SHREE MANGALAM SCHOOL", pageWidth / 2, 28, { align: "center" });

    doc.setFontSize(10);

    doc.text("RIMC & Sainik School Entrance Preparation", pageWidth / 2, 38, {
      align: "center",
    });

    doc.text("Student Progress Report Card", pageWidth / 2, 46, {
      align: "center",
    });

    addWatermark(doc, pageWidth, pageHeight);

    doc.setFontSize(20);
    doc.setTextColor(255, 255, 255);
    doc.text("SHREE MANGALAM SCHOOL", pageWidth / 2, 28, { align: "center" });

    doc.setFontSize(10);
    doc.text("RIMC & Sainik School Entrance Preparation", pageWidth / 2, 38, {
      align: "center",
    });

    // Report Title - Adjusted Y position
    doc.setFontSize(16);
    doc.setTextColor(6, 90, 121);
    doc.text("PROGRESS REPORT CARD", pageWidth / 2, 60, { align: "center" });

    doc.setFontSize(9);
    doc.setTextColor(100, 100, 100);
    doc.text(
      `Issue Date: ${new Date().toLocaleDateString("en-IN")}`,
      pageWidth / 2,
      68,
      { align: "center" },
    );

    // Student Information Box - Adjusted Y position
    doc.setDrawColor(6, 90, 121);
    doc.setFillColor(245, 245, 245);
    doc.roundedRect(15, 78, pageWidth - 30, 55, 3, 3, "F");

    doc.setFontSize(11);
    doc.setTextColor(6, 90, 121);
    doc.text("STUDENT INFORMATION", pageWidth / 2, 90, { align: "center" });

    doc.setFontSize(9);
    doc.setTextColor(75, 75, 75);
    doc.text(`Name: ${studentData.studentName}`, 25, 103);
    doc.text(`Roll No: SMS-${studentData.rollNumber || "SMS001"}`, 120, 103);
    doc.text(
      `Parent / Guardian: ${studentData.parentName || "Mr. Sanjeev Kumar"}`,
      25,
      113,
    );
    doc.text(`Session: ${studentData.session || "2025-26"}`, 120, 113);
    doc.text(
      `DOB: ${new Date(studentData.dob).toLocaleDateString("en-IN")}`,
      25,
      123,
    );
    doc.text(`Phone: ${studentData.phone}`, 120, 123);

    // Exam Details Box - Adjusted Y position
    doc.setDrawColor(6, 90, 121);
    doc.setFillColor(245, 245, 245);
    doc.roundedRect(15, 140, pageWidth - 30, 45, 3, 3, "F");

    doc.setFontSize(11);
    doc.setTextColor(6, 90, 121);
    doc.text("EXAM DETAILS", pageWidth / 2, 153, { align: "center" });

    doc.setFontSize(9);
    doc.setTextColor(75, 75, 75);
    doc.text(`Exam: ${report.examName}`, 25, 166);
    doc.text(`Subject: ${report.examSubject}`, 120, 166);
    doc.text(`Class: ${report.studentClass}`, 25, 176);
    doc.text(
      `Date: ${new Date(report.createdAt).toLocaleDateString("en-IN")}`,
      120,
      176,
    );

    // Performance Summary - Adjusted startY
    let startY = 195;
    doc.setFontSize(11);
    doc.setTextColor(6, 90, 121);
    doc.text("PERFORMANCE SUMMARY", pageWidth / 2, startY, { align: "center" });

    const marksData = [
      [
        "Total Marks",
        report.totalMarks.toString(),
        "Maximum Marks",
        report.totalMarks.toString(),
      ],
      [
        "Marks Obtained",
        report.obtainedMarks.toString(),
        "Percentage",
        `${report.percentage}%`,
      ],
      [
        "Passing Marks",
        report.passingMarks.toString(),
        "Result",
        report.verdict,
      ],
      [
        "Total Questions",
        report.totalQuestions.toString(),
        "Attempted",
        report.attemptedQuestions.toString(),
      ],
      [
        "Correct Answers",
        report.correctAnswers.toString(),
        "Wrong Answers",
        report.wrongAnswers.toString(),
      ],
      [
        "Skipped",
        report.skippedAnswers.toString(),
        "Negative Marks",
        report.negativeMarks.toString(),
      ],
      [
        "Time Taken",
        `${report.timeTaken} min`,
        "Grade",
        report.percentage >= 75
          ? "A+"
          : report.percentage >= 60
            ? "A"
            : report.percentage >= 45
              ? "B"
              : "C",
      ],
    ];

    autoTable(doc, {
      startY: startY + 8,
      body: marksData,
      theme: "plain",
      styles: { fontSize: 9, cellPadding: 3 },
      columnStyles: {
        0: { cellWidth: 45, fontStyle: "bold", textColor: [75, 75, 75] },
        1: { cellWidth: 40, textColor: [33, 33, 33] },
        2: { cellWidth: 45, fontStyle: "bold", textColor: [75, 75, 75] },
        3: { cellWidth: 40, textColor: [33, 33, 33] },
      },
      alternateRowStyles: { fillColor: [248, 248, 248] },
    });

    // Answer Details
    const finalY = doc.lastAutoTable.finalY + 10;
    if (finalY < pageHeight - 80) {
      doc.setFontSize(11);
      doc.setTextColor(6, 90, 121);
      doc.text("ANSWER SHEET", pageWidth / 2, finalY, { align: "center" });

      const answerData = report.answers.map((answer, index) => [
        (index + 1).toString(),
        answer.selectedOptions?.join(", ") || "N/A",
        answer.isCorrect ? "✓" : "✗",
        answer.marksAwarded.toString(),
      ]);

      autoTable(doc, {
        startY: finalY + 5,
        head: [["Q.No.", "Selected Answer", "Status", "Marks"]],
        body: answerData,
        theme: "striped",
        headStyles: {
          fillColor: [6, 90, 121],
          textColor: [255, 255, 255],
          fontSize: 9,
        },
        bodyStyles: { fontSize: 8 },
        columnStyles: {
          0: { cellWidth: 25 },
          1: { cellWidth: 70 },
          2: { cellWidth: 25, halign: "center" },
          3: { cellWidth: 30, halign: "center" },
        },
      });
    }

    // Footer inside border
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text(
      "This is a computer-generated report card",
      pageWidth / 2,
      pageHeight - 15,
      { align: "center" },
    );

    doc.save(`${studentData.studentName}_${report.examName}_ReportCard.pdf`);
  };

  const getScoreColor = (percentage) => {
    if (percentage >= 75) return "#4caf50";
    if (percentage >= 60) return "#2196f3";
    if (percentage >= 45) return "#ff9800";
    return "#f44336";
  };

  const getGrade = (percentage) => {
    if (percentage >= 75) return { grade: "A+", remark: "Outstanding" };
    if (percentage >= 60) return { grade: "A", remark: "Excellent" };
    if (percentage >= 45) return { grade: "B", remark: "Good" };
    if (percentage >= 33) return { grade: "C", remark: "Average" };
    return { grade: "D", remark: "Need Improvement" };
  };

  return (
    <>
      <Navbar />
      <Header image={ReportsBanner} alt={"Shree Mangalam School"} />
      <Container maxWidth="lg" sx={{ py: 5 }}>
        <Box sx={{ mx: "auto", py: 2 }}>
          <Typography
            variant="h4"
            fontWeight={700}
            mb={2}
            sx={{ color: primaryColor }}
          >
            Student Report Card
          </Typography>
          <Typography variant="body1" color="text.secondary" mb={4}>
            Enter your registered phone number and date of birth to view and
            download your report card instantly. Access your academic
            performance, marks, and detailed results securely online.
          </Typography>
        </Box>

        {!studentData ? (
          <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 3 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{
                mb: 3,
                color: primaryColor,
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
              }}
            >
              Student Login Portal
            </Typography>

            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Phone Number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    placeholder="Enter 10-digit mobile number"
                    inputProps={{ maxLength: 10 }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": { borderColor: primaryColor },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Date of Birth"
                    name="dob"
                    value={formData.dob}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": { borderColor: primaryColor },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={loading}
                    sx={{
                      py: 1.5,
                      fontSize: "1.1rem",
                      fontWeight: "bold",
                      background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
                      "&:hover": {
                        background: `linear-gradient(135deg, ${secondaryColor} 0%, ${primaryColor} 100%)`,
                      },
                    }}
                  >
                    {loading ? (
                      <CircularProgress size={24} sx={{ color: "white" }} />
                    ) : (
                      "View Report Card"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </form>

            {error && (
              <Alert severity="error" sx={{ mt: 3 }}>
                {error}
              </Alert>
            )}
          </Paper>
        ) : (
          <>
            {/* Show pending results alert if there are pending results */}
            {resultInfo && resultInfo.type === "PENDING_RESULTS" && (
              <Alert
                severity="warning"
                sx={{
                  mb: 3,
                  bgcolor: "#fff3e0",
                  border: "1px solid #ff9800",
                }}
                icon={<ScheduleIcon />}
                action={
                  <Button
                    color="inherit"
                    size="small"
                    onClick={() => setShowPendingModal(true)}
                  >
                    View Details
                  </Button>
                }
              >
                <strong>Results Pending Declaration!</strong>{" "}
                {resultInfo.message}
              </Alert>
            )}

            {reports.length > 0 && (
              <Alert
                severity="success"
                sx={{
                  mb: 3,
                  bgcolor: "#e8f5e9",
                  border: "1px solid #4caf50",
                }}
                icon={<CheckCircleIcon />}
              >
                <strong>Welcome, {studentData.studentName}!</strong> —{" "}
                {reports.length} report card{reports.length > 1 ? "s" : ""}{" "}
                available
              </Alert>
            )}

            <Button
              variant="outlined"
              onClick={() => {
                setStudentData(null);
                setReports([]);
                setPendingResults([]);
                setResultInfo(null);
                setFormData({ phone: "", dob: "" });
              }}
              sx={{ mb: 3, borderColor: primaryColor, color: primaryColor }}
              startIcon={<PersonIcon />}
            >
              Search Another Student
            </Button>
          </>
        )}

        {studentData && reports.length > 0 && (
          <>
            <Typography
              variant="h5"
              gutterBottom
              sx={{
                mb: 3,
                fontWeight: "bold",
                color: primaryColor,
                borderLeft: `4px solid ${secondaryColor}`,
                pl: 2,
              }}
            >
              Report Cards
            </Typography>

            {reports.map((report) => {
              const gradeInfo = getGrade(report.percentage);
              return (
                <Card
                  key={report._id}
                  sx={{
                    mb: 4,
                    borderRadius: 3,
                    boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                    transition: "transform 0.3s, box-shadow 0.3s",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 12px 48px rgba(0,0,0,0.15)",
                    },
                  }}
                >
                  <CardContent sx={{ p: 0 }}>
                    {/* School Header with Brand Colors */}
                    <Box
                      sx={{
                        background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
                        color: "white",
                        p: 3,
                        borderRadius: "12px 12px 0 0",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{ fontWeight: "bold", letterSpacing: 1 }}
                      >
                        SHREE MANGALAM SCHOOL
                      </Typography>
                      <Typography
                        variant="caption"
                        display="block"
                        sx={{ opacity: 0.9 }}
                      >
                        RIMC & Sainik School Entrance Preparation
                      </Typography>
                    </Box>

                    {/* Report Title */}
                    <Box
                      sx={{ p: 3, borderBottom: `2px solid ${primaryColor}` }}
                    >
                      <Typography
                        variant="h6"
                        align="center"
                        sx={{ fontWeight: "bold", color: primaryColor }}
                      >
                        PROGRESS REPORT CARD
                      </Typography>
                      <Typography
                        variant="caption"
                        align="center"
                        display="block"
                        color="text.secondary"
                      >
                        Issue Date: {new Date().toLocaleDateString("en-IN")}
                      </Typography>
                    </Box>

                    {/* Student Info */}
                    <Box sx={{ p: 3, bgcolor: "#f5f5f5" }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: "bold",
                              color: primaryColor,
                              mb: 2,
                            }}
                          >
                            STUDENT INFORMATION
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Typography variant="body2">
                            <strong>Name:</strong> {studentData.studentName}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Typography variant="body2">
                            <strong>Parent / Guardian:</strong>{" "}
                            {studentData.parentName || "Mr. Sanjeev Kumar"}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Typography variant="body2">
                            <strong>Roll No:</strong> SMS-{studentData.rollNumber || "SMS001"}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Typography variant="body2">
                            <strong>DOB:</strong>{" "}
                            {new Date(studentData.dob).toLocaleDateString(
                              "en-IN",
                            )}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Typography variant="body2">
                            <strong>Phone:</strong> {studentData.phone}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Typography variant="body2">
                            <strong>Session:</strong>{" "}
                            {studentData.session || "2025-26"}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>

                    {/* Exam Details */}
                    <Box sx={{ p: 3 }}>
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: "bold", color: primaryColor, mb: 2 }}
                      >
                        EXAM DETAILS
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2">
                            <strong>Exam Name:</strong> {report.examName}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2">
                            <strong>Subject:</strong> {report.examSubject}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2">
                            <strong>Class:</strong> {report.studentClass}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2">
                            <strong>Exam Date:</strong>{" "}
                            {new Date(report.createdAt).toLocaleDateString(
                              "en-IN",
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>

                    <Divider />

                    {/* Performance Summary */}
                    <Box sx={{ p: 3 }}>
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: "bold", color: primaryColor, mb: 2 }}
                      >
                        PERFORMANCE SUMMARY
                      </Typography>

                      <Grid container spacing={2}>
                        <Grid item xs={6} md={3}>
                          <Paper
                            sx={{
                              p: 2,
                              textAlign: "center",
                              bgcolor: "#e3f2fd",
                            }}
                          >
                            <Typography
                              variant="h6"
                              sx={{ color: primaryColor }}
                            >
                              {report.obtainedMarks}/{report.totalMarks}
                            </Typography>
                            <Typography variant="caption">
                              Marks Obtained
                            </Typography>
                          </Paper>
                        </Grid>
                        <Grid item xs={6} md={3}>
                          <Paper
                            sx={{
                              p: 2,
                              textAlign: "center",
                              bgcolor: "#e8f5e9",
                            }}
                          >
                            <Typography
                              variant="h6"
                              sx={{ color: getScoreColor(report.percentage) }}
                            >
                              {report.percentage}%
                            </Typography>
                            <Typography variant="caption">
                              Percentage
                            </Typography>
                          </Paper>
                        </Grid>
                        <Grid item xs={6} md={3}>
                          <Paper
                            sx={{
                              p: 2,
                              textAlign: "center",
                              bgcolor: "#fff3e0",
                            }}
                          >
                            <Typography
                              variant="h6"
                              sx={{ color: secondaryColor }}
                            >
                              {gradeInfo.grade}
                            </Typography>
                            <Typography variant="caption">Grade</Typography>
                          </Paper>
                        </Grid>
                        <Grid item xs={6} md={3}>
                          <Paper
                            sx={{
                              p: 2,
                              textAlign: "center",
                              bgcolor:
                                report.verdict === "Pass"
                                  ? "#e8f5e9"
                                  : "#ffebee",
                            }}
                          >
                            <Typography
                              variant="h6"
                              color={
                                report.verdict === "Pass"
                                  ? "success.main"
                                  : "error.main"
                              }
                            >
                              {report.verdict}
                            </Typography>
                            <Typography variant="caption">Result</Typography>
                          </Paper>
                        </Grid>
                      </Grid>

                      <Box sx={{ mt: 3 }}>
                        <Typography variant="body2" gutterBottom>
                          Performance Overview
                        </Typography>
                        <LinearProgress
                          variant="determinate"
                          value={report.percentage}
                          sx={{
                            height: 10,
                            borderRadius: 5,
                            backgroundColor: "#e0e0e0",
                            "& .MuiLinearProgress-bar": {
                              background: `linear-gradient(90deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
                              borderRadius: 5,
                            },
                          }}
                        />
                      </Box>
                    </Box>

                    <Divider />

                    {/* Detailed Marks */}
                    <Box sx={{ p: 3 }}>
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: "bold", color: primaryColor, mb: 2 }}
                      >
                        DETAILED ANALYSIS
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={6} sm={4} md={2}>
                          <Box textAlign="center">
                            <Typography variant="h6">
                              {report.totalQuestions}
                            </Typography>
                            <Typography variant="caption">
                              Total Questions
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} sm={4} md={2}>
                          <Box textAlign="center">
                            <Typography variant="h6" color="success.main">
                              {report.correctAnswers}
                            </Typography>
                            <Typography variant="caption">Correct</Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} sm={4} md={2}>
                          <Box textAlign="center">
                            <Typography variant="h6" color="error.main">
                              {report.wrongAnswers}
                            </Typography>
                            <Typography variant="caption">Wrong</Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} sm={4} md={2}>
                          <Box textAlign="center">
                            <Typography variant="h6">
                              {report.skippedAnswers}
                            </Typography>
                            <Typography variant="caption">Skipped</Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} sm={4} md={2}>
                          <Box textAlign="center">
                            <Typography variant="h6">
                              {report.attemptedQuestions}
                            </Typography>
                            <Typography variant="caption">Attempted</Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} sm={4} md={2}>
                          <Box textAlign="center">
                            <Typography variant="h6">
                              {report.timeTaken} min
                            </Typography>
                            <Typography variant="caption">
                              Time Taken
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>

                    {/* Answer Sheet */}
                    <Accordion
                      expanded={expandedReport === report._id}
                      onChange={() =>
                        setExpandedReport(
                          expandedReport === report._id ? null : report._id,
                        )
                      }
                      sx={{ m: 3, borderRadius: 2 }}
                    >
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography
                          fontWeight="bold"
                          sx={{ color: primaryColor }}
                        >
                          <QuizIcon
                            sx={{
                              mr: 1,
                              verticalAlign: "middle",
                              color: primaryColor,
                            }}
                          />
                          View Answer Sheet
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <TableContainer>
                          <Table size="small">
                            <TableHead>
                              <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                                <TableCell>
                                  <strong>Q.No.</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Selected Answer</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Status</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Marks</strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {report.answers.map((answer, idx) => (
                                <TableRow key={answer.questionId} hover>
                                  <TableCell>{idx + 1}</TableCell>
                                  <TableCell>
                                    {answer.selectedOptions?.join(", ") ||
                                      "Not Attempted"}
                                  </TableCell>
                                  <TableCell>
                                    {answer.isCorrect ? (
                                      <Chip
                                        label="Correct"
                                        color="success"
                                        size="small"
                                      />
                                    ) : (
                                      <Chip
                                        label="Incorrect"
                                        color="error"
                                        size="small"
                                      />
                                    )}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      color:
                                        answer.marksAwarded > 0
                                          ? "green"
                                          : "red",
                                    }}
                                  >
                                    {answer.marksAwarded > 0 ? "+" : ""}
                                    {answer.marksAwarded}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </AccordionDetails>
                    </Accordion>

                    {/* Signature and Download */}
                    <Box
                      sx={{
                        p: 3,
                        bgcolor: "#fafafa",
                        borderRadius: "0 0 12px 12px",
                      }}
                    >
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12}>
                          <Button
                            fullWidth
                            variant="contained"
                            startIcon={<DownloadIcon />}
                            onClick={() => downloadPDF(report)}
                            sx={{
                              mt: 2,
                              background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
                              "&:hover": {
                                background: `linear-gradient(135deg, ${secondaryColor} 0%, ${primaryColor} 100%)`,
                              },
                            }}
                          >
                            Download Report Card (PDF)
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </CardContent>
                </Card>
              );
            })}
          </>
        )}

        {studentData && reports.length === 0 && pendingResults.length === 0 && (
          <Paper elevation={3} sx={{ p: 4, textAlign: "center" }}>
            <Typography variant="h6" color="text.secondary">
              No report cards found for this student.
            </Typography>
          </Paper>
        )}

        {/* Pending Results Modal */}
        <Modal
          open={showPendingModal}
          onClose={() => setShowPendingModal(false)}
          aria-labelledby="pending-results-modal"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "95%", sm: 500 },
              bgcolor: "background.paper",
              borderRadius: 3,
              boxShadow: 24,
              p: 4,
              outline: "none",
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <Typography variant="h6" sx={{ color: primaryColor, fontWeight: "bold" }}>
                <ScheduleIcon sx={{ mr: 1, verticalAlign: "middle" }} />
                Results Pending Declaration
              </Typography>
              <IconButton onClick={() => setShowPendingModal(false)} size="small">
                <CloseIcon />
              </IconButton>
            </Box>
            
            <Divider sx={{ mb: 2 }} />
            
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Your results are not yet available. Please check back on the following dates:
            </Typography>
            
            {pendingResults.map((pending, index) => (
              <Paper
                key={index}
                sx={{
                  p: 2,
                  mb: 2,
                  bgcolor: "#fff3e0",
                  border: "1px solid #ffe082",
                  borderRadius: 2,
                }}
              >
                <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: primaryColor }}>
                  {pending.examName}
                </Typography>
                <Typography variant="caption" display="block" color="text.secondary">
                  Subject: {pending.subject}
                </Typography>
                <Typography variant="body2" sx={{ mt: 1, color: secondaryColor, fontWeight: "medium" }}>
                  <ScheduleIcon sx={{ fontSize: 14, mr: 0.5, verticalAlign: "middle" }} />
                  Result will be declared on: {formatDateForDisplay(pending.resultDate, pending.resultTime)}
                </Typography>
              </Paper>
            ))}
            
            <Button
              fullWidth
              variant="contained"
              onClick={() => setShowPendingModal(false)}
              sx={{
                mt: 2,
                background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
                "&:hover": {
                  background: `linear-gradient(135deg, ${secondaryColor} 0%, ${primaryColor} 100%)`,
                },
              }}
            >
              OK, Got it
            </Button>
          </Box>
        </Modal>
      </Container>
      <Footer />
    </>
  );
};

export default Reports;